import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Protected = ({ children }) => {
    const { user } = useAuth();
    if (user === null)
        return (
            <div className="min-h-screen flex items-center justify-center bg-tbv-bg">
                <div className="text-tbv-deep">Verifying…</div>
            </div>
        );
    if (user === false) return <Navigate to="/admin/login" replace />;
    return children;
};

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ContentProvider>
                    <AuthProvider>
                        <Toaster position="top-right" richColors />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <Protected>
                                        <AdminDashboard />
                                    </Protected>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </AuthProvider>
                </ContentProvider>
            </BrowserRouter>
        </div>
    );
}
